<template>
<div class="ui inverted accordion" :id="'downloadSpreadsheetAccordion'+variant" style="padding-top:10px; max-width:800px; clear:both;">
  <div class="title" style="font-size:1.3em;">
    &nbsp; &nbsp; &nbsp;
    <i class="dropdown icon"></i>
    <i class="olive large chart bar icon"></i>
    <!-- <span v-if="variant == 'sales'">
      <span style="color:steelblue;text-decoration:underline;">Download</span> Purchase Data as a SentryKit Spreadsheet
      <span data-inverted="" data-tooltip="Includes Sales and detailed Promo Code data with preset filters" data-position="right center"> <i class="grey info circle icon"></i> </span>
    </span> -->
  </div>
  <div class="content">
    <div class="ui grid" style="margin-left:20px; margin-top:6px">
      <div class="row">
        <div class="three wide column">Send to</div>
        <div class="twelve wide column">
          <div v-if="emails.length > 0" class="ui inverted form" >
           <div v-for="e in emails" class="inline field">
             <div class="ui checkbox labelCursorFix">
               <input :id="e.email" type="checkbox" data-lpignore="true" v-model="e.selected">
               <label :for="e.email">{{e.email}}</label>
             </div>
           </div>
         </div>
         <div v-else>
           You have no verified email addresses
         </div>
       </div>
     </div>
     <div class="row" style="padding-bottom: 0;">
       <div class="three wide column">Options</div>
       <div class="twelve wide column" >
         <div class="ui inverted form">

          <div class="inline field">
           <div class="ui checkbox labelCursorFix">
             <input id="includeAllProducts" type="checkbox" data-lpignore="true" v-model="includeAllProducts">
             <label for="includeAllProducts">Include ALL my products in the spreadsheet</label>
           </div>
          </div>

          <div class="inline fields" >
          <div class="field">
            <div class="ui radio checkbox labelCursorFix">
              <input type="radio" name="daterange" id="daterange1" value="90" checked="checked" v-model="rangeDays">
              <label for="daterange1">Last 90 days  &nbsp; <span style="color:#777;">- or -</span></label>
            </div>
          </div>
          <div class="field">
            <div class="ui radio checkbox labelCursorFix">
              <input type="radio" name="daterange" id="daterange2" value="-1" v-model="rangeDays">
              <label for="daterange2">Custom dates</label>
            </div>
          </div>
          </div>

          <transition name="fadeDown">
          <div class="inline field" :class="sendPhase === 'DATE_INPUT_ERROR' ? 'error' : ''" v-if="rangeDays==-1">
            <input v-model="rangeDateFrom" name="datefrom" type="date" placeholder="yyyy-mm-dd" style="width:165px;">
            <input v-model="rangeDateTo"   name="dateto"   type="date" placeholder="yyyy-mm-dd" style="width:165px;">
          </div>
          </transition>

         </div>
       </div>
     </div>
     <div class="row">
       <div class="three wide column"/>
       <div class="thirteen wide column" style="font-size:.9em">
         This feature is currently in [Preview] - we are likely to change / add things to it.<br/>
         Is there something you'd like to see in the generated spreadsheets? Let us know by sending a feature request. <br/><br/>
         Also, while in preview: date range is 120 days max, earliest date is 60 days before signing up to SentryKit. (Need more? Contact us to lift your limits.)
       </div>
     </div>
     <div class="row">
       <div class="three wide column"></div>
       <div class="three wide column">
         <div class="ui primary button" :class="sendPhase === 'IN_PROGRESS' ? 'loading' : selectedEmailAddresses.length == 0 || emails.length == 0 || sendPhase === 'OK_FRESH' ? 'disabled' : ''" @click="send()">Send</div>
       </div>
       <div class="nine wide column">

        <small v-show="selectedEmailAddresses.length<1 && emails.length > 0" style="color:#777;">
          &nbsp; &nbsp; &nbsp; select an email <br/>
          &nbsp; &nbsp; &nbsp; address above
        </small>

        <transition name="fadeDown">
        <div v-show="sendPhase === 'OK_FRESH' || sendPhase === 'FAILED' || sendPhase === 'TOO_MANY_REQUESTS'" class="ui positive message">
          <i class="close icon"></i>

          <div class="header" v-if="sendPhase === 'OK_FRESH'">
            Your request has been received
          </div>
          <p v-if="sendPhase === 'OK_FRESH'">The spreadsheet will be delivered to your inbox in a couple of minutes.</p>

          <div v-if="sendPhase === 'TOO_MANY_REQUESTS'">The system is already compiling a spreadsheet for you, please try again in a couple of minutes.</div>

          <div v-if="sendPhase === 'FAILED'">Could not send request</div>
        </div>
      </transition>
      </div>
     </div>
    </div>
  </div>
</div>
</template>

<script>
import $ from 'jquery'
export default {
  data: function () {
    const nowDateString = new Date(Date.now()).toISOString().split('T')[0]
    return {
      includeAllProducts: false,
      emails: [],
      rangeDays: 90,
      rangeDateFrom: nowDateString,
      rangeDateTo: nowDateString,
      sendPhase: null,
      urlSlug: {
        'sales': 'SALES',
      },
    }
  },
  props: ['chartLastLoadedAt', 'product', 'variant'],
  methods: {
    send: function () {
      if (Number(this.rangeDays) === -1) { // if we expect a date range
        if (String(this.rangeDateFrom).match(/^20\d{2}-[01]\d-[0123]\d$/) === null || String(this.rangeDateTo).match(/^20\d{2}-[01]\d-[0123]\d$/) === null) {
          this.sendPhase = 'DATE_INPUT_ERROR'
          setTimeout(() => { if (this.sendPhase === 'DATE_INPUT_ERROR') this.sendPhase = '' }, 3000)
          return
        } else {
          this.sendPhase = '' // clear the previous error if there was one
        }
      }

      this.sendPhase = 'IN_PROGRESS'
      this.$http.post('/api/order/spreadsheet/v1.2/' + this.urlSlug[this.variant] + '/email-request', {
        productGroupId: this.includeAllProducts ? null : this.product.productGroupId,
        lookbackDays: this.rangeDays,
        rangeDateFrom: this.rangeDateFrom,
        rangeDateTo: this.rangeDateTo,
        emailAddresses: this.selectedEmailAddresses,
      }).then((resp) => {
        this.sendPhase = 'OK_FRESH'
        setTimeout(() => { if (this.sendPhase === 'OK_FRESH') this.sendPhase = 'OK' }, 5000)
      }, (resp) => {
        this.sendPhase = resp.status === 429 ? 'TOO_MANY_REQUESTS' : 'FAILED'
      })
    },
    init: function () {
      this.$http.get('/api/identity/email-addresses').then(function (resp) {
        this.emails = resp.body.filter(e => e.isVerified).map(e => $.extend(e, {selected: false}))
        if (this.emails.length === 1) this.emails[0].selected = true
      }, (resp) => {
        console.log(resp)
      })
    },
  },
  created: function () {
    this.init()
  },
  mounted: function () {
    $('#downloadSpreadsheetAccordion' + this.variant).accordion('refresh')
    $('#emailsDropdown').dropdown()
    $(this.$el).find('.message .close').click(function () { $(this).closest('.message').hide(200) })
  },
  watch: {
    'chartLastLoadedAt': function (val) {
      this.init()
      this.includeAllProducts = false
    }
  },
  computed: {
    selectedEmailAddresses: function () { return this.emails.filter(e => e.selected).map(e => e.email) }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// SpreadsheetDownloadWidget.vue?6111cf4a